module.exports = __webpack_public_path__ + "r-v3/img/ico_info_darkgray.5293e519.svg";